/** @jsxImportSource @emotion/react */
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { BoxStore } from '../../stores/RussianPoker/Box.store'
import WinNotice from '../WinNotice'

const BonusWin: FC<{
  className?: string
  box: BoxStore
}> = observer(({ className, box }) => {
  const { bonus } = box
  const { t } = useTranslation()

  return (
    <WinNotice
      className={className}
      title={t('bonusWin')}
      ratio={bonus.ratio}
      amount={bonus.netWin}
      color="green"
    />
  )
})

export default BonusWin
